module.exports = __webpack_public_path__ + "72b6f2c9990bd3d37b8013a59ed78902.otf";